import { formatDate, formatDateTime, formatDateTimeFull, formatRelative } from "../format/dates"

export const DateText = ({ value, withTime = false, relative = false }) => {
  if (!value) return <span className="ds-date">—</span>
  const label = relative ? formatRelative(value) : withTime ? formatDateTime(value) : formatDate(value)
  return (
    <span className="ds-date" title={formatDateTimeFull(value)}>
      {label}
    </span>
  )
}

export default DateText
